/**
 * Stable random index per component mount for meme media rotation.
 *  */

import { useState } from 'react';

export function useRandomMemeMediaIndex(length: number): number {
  return useState(() => {
    if (length <= 0) return 0;
    return Math.floor(Math.random() * length);
  })[0];
}
